import { env } from '@/services/EnvironmentVariables'
import { Alert } from '@/UIComponents2/Alert'

export function BrowserAlert({ action }: { action: string }) {
    if (env.IS_ELECTRON) {
        return null
    }
    return (
        <Alert variant="solid" level="warning" contentClassName="inline-block">
            <span>Download the </span>
            <a className="font-bold" href="https://musesessions.co/download" target="_blank">
                Muse App
            </a>
            <span> to {action}</span>.
        </Alert>
    )
}
